import { Dialog } from "primereact/dialog";

const ConfirmDialogBox = ({
  visible,
  onHide,
  onConfirm,
  title = "",
  message = "",
  confirmLabel = "Yes",
  cancelLabel = "No",
}) => {
  const isDeleteAction =
    confirmLabel?.toLowerCase().includes("delete");

  const footer = (
    <div
      className={`flex
        ${cancelLabel ? "justify-between" : "justify-end"}
      `}
    >
      {cancelLabel && (
        <button
          onClick={onHide}
          className="
            px-4 py-2 rounded-md border
            border-slate-300 dark:border-slate-600
            text-slate-700 dark:text-slate-800
            hover:bg-slate-200 dark:hover:bg-slate-700 dark:hover:text-slate-200
            transition
          "
        >
          {cancelLabel}
        </button>
      )}

      {confirmLabel && (
        <button
          onClick={onConfirm}
          autoFocus
          className={`
            px-4 py-2 rounded-md text-white transition
            ${
              isDeleteAction
                ? "bg-red-600 hover:bg-red-700"
                : "bg-green-800 hover:bg-green-900"
            }
          `}
        >
          {confirmLabel}
        </button>
      )}
    </div>
  );

  return (
   <Dialog
  visible={visible}
  onHide={onHide}
  footer={footer}
  modal
  dismissableMask   
  closeOnEscape    
  closable={false}  
  className="w-[90vw] max-w-md bg-white rounded"
>
      <div>
        {title && (
          <h5 className="text-lg font-semibold mb-2 text-slate-800 dark:text-slate-800">
            {title}
          </h5>
        )}

        {message && (
          <p className="text-base text-slate-600 dark:text-slate-300">
            {message}
          </p>
        )}
      </div>
    </Dialog>
  );
};

export default ConfirmDialogBox;
